export default {
  placeholder: 'Sprache auswählen',
};
